import { render } from "./FootWear.vue?vue&type=template&id=7102825f"
import script from "./FootWear.vue?vue&type=script&lang=js"
export * from "./FootWear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__